/**
 * Per-business filter dots at the bottom of the sidebar nav.
 * "All businesses" + one entry per business, colour-coded.
 */
export function SidebarBusinessFilter({ businesses, activeBusiness, setActiveBusiness, expanded }) {
  return (
    <div className="mb-1 mt-1">
      {expanded && (
        <div className="text-[9px] uppercase tracking-[0.14em] font-semibold px-2 pt-3 pb-1"
          style={{ color: 'var(--pd-subtle)' }}>Businesses</div>
      )}
      <div className="space-y-0.5">
        <button
          data-testid="business-filter-all"
          onClick={() => setActiveBusiness(null)}
          className={`sidebar-nav-item pd-sidebar-nav-item ${!activeBusiness ? 'active' : ''}`}
          style={{ minHeight: 40, justifyContent: expanded ? 'flex-start' : 'center', padding: expanded ? '0 10px' : '0' }}
        >
          <div className="w-9 h-9 rounded-xl flex items-center justify-center flex-shrink-0">
            <div className="w-3 h-3 rounded-md" style={{
              background: !activeBusiness ? 'var(--pd-text)' : 'transparent',
              border: '2px solid var(--pd-muted)',
            }} />
          </div>
          {expanded ? (
            <div className="sidebar-label flex-1 text-left">
              <div className="text-[12px] font-semibold" style={{ color: !activeBusiness ? 'var(--pd-text)' : 'var(--pd-muted)' }}>All businesses</div>
            </div>
          ) : null}
        </button>
        {businesses.map((biz) => {
          const active = activeBusiness?.id === biz.id;
          return (
            <button
              key={biz.id}
              data-testid={`business-filter-dot-${biz.id}`}
              onClick={() => setActiveBusiness(active ? null : biz)}
              className={`sidebar-nav-item pd-sidebar-nav-item ${active ? 'active' : ''}`}
              style={{ minHeight: 40, justifyContent: expanded ? 'flex-start' : 'center', padding: expanded ? '0 10px' : '0' }}
            >
              <div className="w-9 h-9 rounded-xl flex items-center justify-center flex-shrink-0">
                <div className="w-3 h-3 rounded-md" style={{ background: active ? biz.color : 'transparent', border: `2px solid ${biz.color}` }} />
              </div>
              {expanded ? (
                <div className="sidebar-label flex-1 text-left">
                  <div className="text-[12px] font-semibold" style={{ color: active ? 'var(--pd-text)' : 'var(--pd-muted)' }}>{biz.shortCode}</div>
                  <div className="text-[9px] mt-0.5" style={{ color: 'var(--pd-subtle)' }}>{biz.name}</div>
                </div>
              ) : null}
            </button>
          );
        })}
      </div>
    </div>
  );
}
